"use strict";
var React = require("react");
var cx = require("classnames");

var Welcome = React.createClass({
    getInitialState: function() {
      return {
          showIntro: false,
          introSlide: 1
      };
    },
    componentDidMount: function()  {
      var seenIntro = localStorage.getItem("shownIntro");
      if (seenIntro) {
        if(seenIntro === "true") {
          console.log('dont show intro')
        } else {
          console.log('show intro at slide number: '+ seenIntro)
          this.showIntro(seenIntro);
        }
      } else {
        this.showIntro(1);
        console.log('show intro')
      }
    },
    showIntro: function(index) {
      console.log('showing slide '+ index)
      this.setState({ "introSlide": index, "showIntro": true });
      localStorage.setItem("shownIntro", index);
    },
    nextStep: function() {
      var nextSlide = parseInt(this.state.introSlide) + 1;
      this.showIntro(nextSlide);
    },
    prevStep: function() {
      var nextSlide = parseInt(this.state.introSlide) -1;
      this.showIntro(nextSlide);
    },
    closeIntro: function() {
      this.setState({ "showIntro": false });
      localStorage.setItem("shownIntro", "true");
    },
    render: function() {
      var wrapperClasses = cx({
        "onboarding-wrapper": true,
        "active": this.state.showIntro
      });
      var step1 = cx({
          "step-circle": true,
          "active": this.state.introSlide === 1,
          "read": this.state.introSlide >= 1
      });
      var step2 = cx({
          "step-circle": true,
          "active": this.state.introSlide === 2,
          "read": this.state.introSlide >= 2
      });
      var step3 = cx({
          "step-circle": true,
          "active": this.state.introSlide === 3,
          "read": this.state.introSlide >= 3
      });
      var step4 = cx({
          "step-circle": true,
          "active": this.state.introSlide === 4,
          "read": this.state.introSlide >= 4
      });
      console.log('slide', this.state.introSlide)
        return (
            <div className={wrapperClasses}>
              <div className="onboarding-box">

                {(this.state.introSlide == 1) &&
                  <div className="onboarding-box-content">
                    <h4>1 Velkomin í Búnaðarbankann!</h4>
                    <p>Lorem ipsum deloris delorian after eight ninteen sixty nine for hundred and twenty power towards the sky.</p>
                  </div>
                }
                {(this.state.introSlide == 2) &&
                  <div className="onboarding-box-content">
                    <h4>2 Velkomin í Búnaðarbankann!</h4>
                    <p>Lorem ipsum deloris delorian after eight ninteen sixty nine for hundred and twenty power towards the sky.</p>
                  </div>
                }
                {(this.state.introSlide == 3) &&
                  <div className="onboarding-box-content">
                    <h4>3 Velkomin í Búnaðarbankann!</h4>
                    <p>Lorem ipsum deloris delorian after eight ninteen sixty nine for hundred and twenty power towards the sky.</p>
                  </div>
                }
                {(this.state.introSlide == 4) &&
                  <div className="onboarding-box-content">
                    <h4>4 Velkomin í Búnaðarbankann!</h4>
                    <p>Lorem ipsum deloris delorian after eight ninteen sixty nine for hundred and twenty power towards the sky.</p>
                  </div>
                }

                <div className="onboarding-box-footer">
                  {(this.state.introSlide > 1) &&
                  <button className="btn btn-default btn-back" onClick={this.prevStep}><i className="far fa-chevron-left"></i></button>
                  }
                  {(this.state.introSlide < 4) ?
                  <button className="btn btn-primary" onClick={this.nextStep}>Næsta</button>
                  :
                  <button className="btn btn-primary" onClick={this.closeIntro}>Loka</button>
                  }
                  <div className="onboarding-steps-wrapper">
                    <div className={step1}></div>
                    <div className={step2}></div>
                    <div className={step3}></div>
                    <div className={step4}></div>
                  </div>
                </div>
              </div>
            </div>
        );
    }
});

module.exports = Welcome;



// WEBPACK FOOTER //
// ./app/scripts/ui/Onboarding/Welcome.react.js